import React from 'react';
import {t} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {StyledTransactionType} from './style';
// import {Tag} from 'antd';
import {Type} from "bukku/redux/Transaction/helper";
import BukkuTooltip from '../Tooltip';
import BukkuEllipsisTag from '../Tag';

export function getTypeName(type, isShort = false) {
    let color, typeText, shortTypeText;
    switch (type) {
        // Sales
        case Type.sale_quote:
            color = '';
            typeText = t`Quotation`;
            break;
        case Type.sale_order:
            color = '';
            typeText = t`Sales Order`;
            break;
        case Type.sale_delivery_order:
            color = '';
            typeText = t`Delivery Order`;
            break;
        case Type.sale_invoice:
            color = 'green';
            typeText = t`Invoice`;
            break;
        case Type.sale_credit_note:
            color = 'red';
            typeText = t`Credit Note`;
            break;
        case Type.sale_payment:
            color = 'green';
            typeText = t`Sales Payment`;
            shortTypeText = t`Payment`;
            break;
        case Type.sale_refund:
            color = 'red';
            typeText = t`Sales Refund`;
            shortTypeText = t`Refund`;
            break;
        // Purchases
        case Type.purchase_order:
            color = '';
            typeText = t`Purchase Order`;
            break;
        case Type.purchase_goods_received_note:
            color = '';
            typeText = t`Goods Received Note`;
            break;
        case Type.purchase_bill:
            color = 'red';
            typeText = t`Bill`;
            break;
        case Type.purchase_credit_note:
            color = 'green';
            typeText = t`Purchase Credit Note`;
            shortTypeText = t`Credit Note`;
            break;
        case Type.purchase_payment:
            color = 'red';
            typeText = t`Purchase Payment`;
            shortTypeText = 'Payment';
            break;
        case Type.purchase_refund:
            color = 'green';
            typeText = t`Purchase Refund`;
            shortTypeText = 'Refund';
            break;

        // Bank
        case Type.bank_income:
            color = 'green';
            typeText = t`Money In`;
            break;
        case Type.bank_expense:
            color = 'red';
            typeText = t`Money Out`;
            break;
        case Type.bank_transfer:
            color = '';
            typeText = t`Bank Transfer`;
            shortTypeText = t`Transfer`;
            break;
        case Type.bank_adjustment:
            color = '';
            typeText = t`Bank Adjustment`;
            break;

            // Receipt / Voucher
        case Type.official_receipt:
            typeText = t`Official Receipt`;
            break;
        case Type.payment_voucher:
            typeText = t`Payment Voucher`;
            break;

        // Opening
        case 'opening':
            color = '';
            typeText = t`Opening Transaction`;
            break;
        case 'opening_invoice':
            color = '';
            typeText = t`Invoice`;
            break;
        case 'opening_sale_credit_note':
            color = '';
            typeText = t`Credit Note`;
            break;
        case 'opening_bill':
            color = '';
            typeText = t`Bill`;
            break;
        case 'opening_purchase_credit_note':
            color = '';
            typeText = t`Purchase Credit Note`;
            break;
        case 'opening_stock_adjustment':
            color = '';
            typeText = t`Stock Adjustment`;
            break;

        // Inventory
        case Type.stock_adjustment:
            color = '';
            typeText = t`Stock Adjustment`;
            shortTypeText = t`Adjustment`;
            break;

        case Type.stock_transfer:
            color = '';
            typeText = t`Stock Transfer`;
            shortTypeText = t`Transfer`;
            break;

        case Type.stock_value:
            color = '';
            typeText = t`Periodic Value`;
            break;

        // Accounting
        case Type.journal_entry:
            color = '';
            typeText = t`Journal Entry`;
            break;
        case Type.tax_deemed_payment:
            color = '';
            typeText = t`Deemed Payment`;
            break;
        case Type.contra:
            color = '';
            typeText = t`Contra`;
            break;
        case Type.fixed_asset:
            color = '';
            typeText = t`Fixed Asset`;
            break;

        // Assets
        case Type.asset_depreciation:
            color = '';
            typeText = t`Asset Depreciation`;
            break;
        case Type.asset_disposal:
            color = '';
            typeText = t`Asset Disposal`;
            break;

        // Other
        case 'opening_balance':
            color = '';
            typeText = t`Opening Balance`;
            break;
        case 'closing_balance':
            color = '';
            typeText = t`Closing Balance`;
            break;
        case 'unrealised_gain_loss':
            color = '';
            typeText = t`Unrealised Gain`;
            break;
        case 'earning':
            color = '';
            typeText = t`Earning`;
            break;

        default: color = null; break;
    }
    if (isShort)
        return [color, shortTypeText || typeText];
    return [color, typeText];
}
function TransactionType(props) {
    const {
        record,
        isShort,
        type,
        plainText,
    } = props;
    const parsedType = record?.type || type;
    const [color, typeText] = getTypeName(parsedType, isShort);

    if (!plainText) {
        return (
            <StyledTransactionType>
                <BukkuTooltip title={typeText}>
                    <BukkuEllipsisTag color={color}>{ typeText }</BukkuEllipsisTag>
                </BukkuTooltip>
            </StyledTransactionType>
        );
    }
    return (
        <StyledTransactionType>
            <span className="plain-text">{ typeText }</span>
        </StyledTransactionType>
    );
}

TransactionType.defaultProps = {
    isShort: false,
};

export default withI18n()(TransactionType);
